class WorkStockItem {
  constructor (data = {}) {
    this.id = data.id;
    this.reportOfSicknessId = data.reportOfSicknessId;
    this.employerCustomerNumber = data.employerCustomerNumber;
    this.employeeCustomerNumber = data.employeeCustomerNumber;
    this.action = data.action;
    this.workStockType = data.workStockType;
    this.reason = data.reason;
    this.data = data.data;
    this.comment = data.comment;
    this.treatedBy = data.treatedBy;
    this.status = data.status;
    this.createdOn = data.createdOnIsoDateTime;
    this.userCreated = data.userCreated;
    this.modifiedOn = data.modifiedOnDateTime;
    this.userModified = data.userModified;
  }
}

const WorkStockItemStates = {
  New: 'New',
  Reviewing: 'Reviewing',
  Closed: 'Closed'
};

export {
  WorkStockItem,
  WorkStockItemStates
};
